



































import { useSave } from '@/composables';
import { BaseModuleEditor } from '../base';

export default {
  name: 'ColorfulSkyEditor',
  mixins: [BaseModuleEditor],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props: any) {
    const { buffer, save } = useSave(props, {
      path: 'model',
    });
    return {
      buffer,
      save,
    };
  },
};
